import { render, staticRenderFns } from "./EmailTokenLoginForm.vue?vue&type=template&id=0c8f6ead&scoped=true&"
import script from "./EmailTokenLoginForm.vue?vue&type=script&lang=js&"
export * from "./EmailTokenLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailTokenLoginForm.vue?vue&type=style&index=0&id=0c8f6ead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8f6ead",
  null
  
)

export default component.exports